import React from 'react';
import { Modal, Button, Steps, Typography, Space } from 'antd';
import {
  EllipsisOutlined,
  ShareAltOutlined,
  AppstoreAddOutlined,
  PlusSquareOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';

const { Paragraph, Text } = Typography;

/**
 * Guia visual iOS — a Apple não permite criar o atalho por código.
 * Fluxo real no Safari recente: ⋯ → Compartilhar → Ver mais → Adicionar à Tela de Início.
 */
const IosInstallGuideModal = ({ open, onClose }) => (
  <Modal
    open={open}
    onCancel={onClose}
    title="Instalar o Saldo Ativo no iPhone"
    footer={
      <Button type="primary" block size="large" onClick={onClose}>
        Entendi
      </Button>
    }
    destroyOnClose
  >
    <Paragraph type="secondary" style={{ marginBottom: 20 }}>
      No iOS, só o Safari consegue criar o atalho (a Apple não deixa o site fazer isso sozinho). Siga:
    </Paragraph>
    <Steps
      direction="vertical"
      size="small"
      current={-1}
      items={[
        {
          title: 'Toque em ⋯ (mais)',
          description: 'No canto inferior direito da barra do Safari, toque nos três pontinhos.',
          icon: <EllipsisOutlined />,
        },
        {
          title: 'Compartilhar',
          description: 'Na lista que abrir, toque em “Compartilhar”.',
          icon: <ShareAltOutlined />,
        },
        {
          title: 'Ver mais',
          description: 'Role a folha de compartilhamento e toque em “Ver mais” se “Adicionar à Tela de Início” não aparecer na primeira lista.',
          icon: <AppstoreAddOutlined />,
        },
        {
          title: 'Adicionar à Tela de Início',
          description: 'Toque em “Adicionar à Tela de Início”.',
          icon: <PlusSquareOutlined />,
        },
        {
          title: 'Confirmar',
          description: 'Toque em “Adicionar”. O ícone do Saldo Ativo aparece na tela inicial.',
          icon: <CheckCircleOutlined />,
        },
      ]}
    />
    <Space direction="vertical" size={4} style={{ marginTop: 16 }}>
      <Text type="secondary" style={{ fontSize: 13 }}>
        Em algumas versões do Safari o ícone de Compartilhar já aparece direto na barra (sem o ⋯). Se estiver no Chrome ou outro navegador, abra o site no Safari.
      </Text>
    </Space>
  </Modal>
);

export default IosInstallGuideModal;
